import { selectBlocksByNode } from '@octopus-do/octopus-project-core'
import type React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { Block } from '../Block'
import css from './Blocks.module.scss'

type Props = {
  nodeId: string
}

const Blocks: React.FC<Props> = ({ nodeId }) => {
  const ids = useSelector(selectBlocksByNode(nodeId), shallowEqual)

  if (!ids || ids.length === 0) {
    return (
      <div className={css.container}>
        <div className={css.ghost} />
      </div>
    )
  }

  return (
    <div className={css.container}>
      {ids.slice(0, 10).map((blockId, index) => (
        <Block
          key={blockId}
          blockId={blockId}
          isFirst={index === 0}
          isLast={index === 9}
        />
      ))}
    </div>
  )
}

export default Blocks
